import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';

import { AppComponent } from './app.component';
import { ConsultasSqlApi, SDKBrowserModule } from './shared/lb-sdk/index';
import { DisplayClienteComponent } from './display-cliente/display-cliente.component';
import { DisplayClienteV2Component } from './display-cliente-v2/display-cliente-v2.component';
import { AppRoutingModule } from './app-routing.module';
import { DisplayClienteModule } from './display-cliente/display-cliente.module';

import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';

import { AuthService } from './shared/auth/auth.service';
import { LoginClienteComponent } from './login-cliente/login-cliente.component';
import { ZeroPadding } from './shared/zero-padding.pipe';
import { ToastrModule } from 'ngx-toastr';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { GrillaTurnosComponent } from './grilla-turnos/grilla-turnos.component';
import { ListadoEncuestasComponent } from './listado-encuestas/listado-encuestas.component';
import { AbmBannersComponent } from './abm-banners/abm-banners.component';
import { AbmParametrosComponent } from './abm-parametros/abm-parametros.component';
import { BannerService } from './services/banner.service';
@NgModule({
  declarations: [
    AppComponent,
    DisplayClienteComponent,
    DisplayClienteV2Component,
    GrillaTurnosComponent,
    LoginClienteComponent,ZeroPadding,ListadoEncuestasComponent,
    AbmBannersComponent,
    AbmParametrosComponent
  ],
  imports: [
    BrowserModule,BrowserAnimationsModule,
    FormsModule,
    HttpModule,
    SDKBrowserModule.forRoot(),AppRoutingModule,DisplayClienteModule,NgxSpinnerModule,ToastrModule.forRoot(),
  ],
  providers: [NgxSpinnerService, AuthService, BannerService],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// E:/R1/Angular/turnero/web-visor-cliente/src/app/app.module.ts